import { __decorate, __extends } from "tslib";
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Button.prototype, "variantClasses", {
        get: function () {
            if (this.variants && Array.isArray(this.variants)) {
                return this.variants.map(function (variant) { return 'c-btn--' + variant; }).join(" ");
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ default: false })
    ], Button.prototype, "moreSpacing", void 0);
    __decorate([
        Prop({ default: false })
    ], Button.prototype, "disabled", void 0);
    __decorate([
        Prop({ default: false })
    ], Button.prototype, "iconOnly", void 0);
    __decorate([
        Prop()
    ], Button.prototype, "iconName", void 0);
    __decorate([
        Prop()
    ], Button.prototype, "variants", void 0);
    __decorate([
        Prop({ default: '' })
    ], Button.prototype, "text", void 0);
    Button = __decorate([
        Component
    ], Button);
    return Button;
}(Vue));
export default Button;
